import { useEffect, useRef } from "react";
import { saveCapsuleEvent } from "./download";
import { useT } from "./i18n";
import { Icon } from "./Icon";
import { announceSealed, useSealed } from "./sealed";
import { formatTime } from "./time";

/** "Your capsule is sealed" on the page Write led to (PLAN.md 4.31); gone once the member leaves that page. */
export function SealedNotice({ path }: { path: string }) {
  const t = useT();
  const sealed = useSealed();
  const seen = useRef(false);
  useEffect(() => {
    if (!sealed) {
      seen.current = false;
      return;
    }
    if (path === sealed.on) seen.current = true;
    else if (seen.current) announceSealed(null);
  }, [sealed, path]);
  if (!sealed || path !== sealed.on) return null;

  const who = sealed.audience.kind === "public" ? t.sealedNotice.everyone : sealed.audience.kind === "self" ? t.sealedNotice.self : t.sealedNotice.people(sealed.audience.count);
  return (
    <section className="sealed-notice" role="status" aria-labelledby="sealed-notice-title">
      <span className="sealed-notice-icon" aria-hidden="true"><Icon name="lock" size={20} /></span>
      <div>
        <h2 id="sealed-notice-title">{t.sealedNotice.title}</h2>
        <p>{t.sealedNotice.opens(formatTime(sealed.unlockAt))} {who}</p>
        {sealed.copy && !sealed.files && (
          <p className="small">
            {t.sealedNotice.copyNote}{" "}
            <button type="button" className="small" onClick={() => saveCapsuleEvent(sealed.copy!)}>{t.sealedNotice.download}</button>
          </p>
        )}
        {sealed.copy && sealed.files && <p className="small muted">{t.sealedNotice.filesNote}</p>}
      </div>
      <button type="button" className="icon-button" aria-label={t.sealedNotice.close} title={t.sealedNotice.close} onClick={() => announceSealed(null)}>
        <Icon name="close" size={16} />
      </button>
    </section>
  );
}
